import * as React from 'react'
import { createRoot } from 'react-dom/client'
import '../styles/index.css'
import '../lib/radix-popover-fix'

const componentMapping = {
  'hunt-achievements-card': () => import('../models/hunt-achievements/views/hunt-achievements-chart-view'),
  'react-test': () => import('../components/react-test'),
  'subscription-dashboard-card-view': () => import('../models/subscription/views/subscription-dashboard-card-view'),
  'user-scheduled-hunts-dashboard-card-view': () => import('../models/user-scheduled-hunts/views/user-scheduled-hunts-dashboard-card-view'),
  'user-scheduled-hunts-dashboard-view': () => import('../models/user-scheduled-hunts/views/user-scheduled-hunts-dashboard-view'),
  'concierge-dashboard-card-view': () => import('../models/tenant/views/concierge-dashboard-card-view'),
  'changelog-view': () => import('../models/cms/views/changelog-view'),
  'changelog-version-view': () => import('../models/cms/views/changelog-version-view'),
  'notes-dashboard': () => import('../models/notes/views/notes-dashboard-view'),
  'commission-calculator-view': () => import('../models/commissions/views/commission-calculator-view'),
  'commission-report-view': () => import('../models/commissions/views/commission-report-view'),
} as const

const rootMap = new WeakMap()

function initializeReactComponents() {
  document.querySelectorAll('[data-react-component]').forEach(async (mountPoint) => {
    const componentName = mountPoint.getAttribute('data-react-component') as keyof typeof componentMapping
    if (componentName && componentMapping[componentName]) {
      try {
        const { default: Component } = await componentMapping[componentName]()

        let root = rootMap.get(mountPoint)
        if (!root) {
          root = createRoot(mountPoint)
          rootMap.set(mountPoint, root)
        }

        root.render(React.createElement(Component))
      }
      catch (error) {
        console.error(`Failed to load component: ${componentName}`, error)
      }
    }
  })
}

document.addEventListener('DOMContentLoaded', initializeReactComponents)

document.addEventListener('turbolinks:load', initializeReactComponents)
